import { FormFieldType, HiddenBuilder, IFormField } from 'meta/form'

export const getHiddenFiscalSeal = (fieldName: string, value: string): IFormField<FormFieldType.hidden> => {
  return new HiddenBuilder(fieldName).addRequiredValidation().addValue(value).build()
}

export const getHiddenSeatId = (fieldName: string, value: string): IFormField<FormFieldType.hidden> => {
  return new HiddenBuilder(fieldName).addValue(value).addRequiredValidation().build()
}
